import React from 'react';
import styled from 'styled-components';
import { useGlobalContext } from '../context/context';
import { Pie3D, Column3D, Bar3D, Doughnut2D } from './Charts';
const Repos = () => {
  const { repos } = useGlobalContext();

  //language chart data
  const languages = repos.reduce((total, item) => {
    const { language, stargazers_count } = item;
    if (!language) return total;
    if (!total[language]) {
      total[language] = { label: language, value: 1, stars: stargazers_count };
    } else {
      total[language] = {
        ...total[language],
        value: total[language].value + 1,
        stars: total[language].stars + stargazers_count,
      };
    }
    return total;
  }, {});

  //most used language
  const mostUsed = Object.values(languages)
    .sort((a, b) => {
      return b.value - a.value;
    })
    .slice(0, 5);

  //most stars per language
  const stars = Object.values(languages)
    .sort((a, b) => b.stars - a.stars)
    .map((item) => {
      return { ...item, value: item.stars };
    })
    .slice(0, 5);

  //most forks
  const mostForks = repos
    .map((repo) => {
      return { label: repo.name, value: repo.forks_count };
    })
    .sort((a, b) => b.value - a.value)
    .slice(0, 5);

  //most stars per repo
  const mostStars = repos
    .map((repo) => {
      return { label: repo.name, value: repo.stargazers_count };
    })
    .sort((a, b) => b.value - a.value)
    .slice(0, 5);

  //another way
  // let { starsRepo, forks } = repos.reduce(
  //   (total, item) => {
  //     const { stargazers_count, forks, name } = item;
  //     total.starsRepo[stargazers_count] = {
  //       label: name,
  //       value: stargazers_count,
  //     };
  //     total.forks[forks] = { label: name, value: forks };
  //     return total;
  //   },
  //   {
  //     starsRepo: {},
  //     forks: {},
  //   }
  // );

  // starsRepo = Object.values(starsRepo).slice(-5).reverse();
  // forks = Object.values(forks).slice(-5).reverse();
  // console.log(starsRepo);

  return (
    <section className='section'>
      <Wrapper className='section-center'>
        {/* <ExampleChart data={chartData} /> */}
        <Pie3D data={mostUsed} />
        <Column3D data={mostStars} />
        <Doughnut2D data={stars} />
        <Bar3D data={mostForks} />
        <div></div>
      </Wrapper>
    </section>
  );
};

const Wrapper = styled.div`
  display: grid;
  justify-items: center;
  gap: 2rem;
  @media (min-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1200px) {
    grid-template-columns: 2fr 3fr;
  }

  div {
    width: 100% !important;
  }
  .fusioncharts-container {
    width: 100% !important;
  }
  svg {
    width: 100% !important;
    border-radius: var(--radius) !important;
  }
`;

export default Repos;
